<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-button @click="showNewFile" class="float-right" icon-left="plus" rounded>Upload new file</b-button>
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column field="name" label="File name">
            <a :href="props.row.fullPath" target="_blank">
              {{
              props.row.name
              }}
            </a>
          </b-table-column>
          <b-table-column field="extension" label="Type">
            {{
            props.row.extension
            }}
          </b-table-column>
          <b-table-column field="size" label="Size">
            {{
            props.row.size | fileSize
            }}
          </b-table-column>
          <b-table-column field="uploaded" label="Uploaded">
            {{
            props.row.mtime | shortDatetime
            }}
          </b-table-column>
          <b-table-column field="delete" label="Delete" class="remove-column">
            <span class="remove" v-on:click.stop="removeFile(props.row.name)">
              <b-icon icon="trash-can-outline" />
              <div v-if="props.row.showDelete" class="confirm">
                <b-button type="is-light" @click.stop="cancelRemove">Cancel</b-button>
                <b-button type="is-danger" @click.stop="deleteFile(props.row.name)">Delete</b-button>
              </div>
            </span>
          </b-table-column>
          <b-table-column field="_id" label="Edit" class="edit-column">
            <span class="edit" v-on:click="editFile(props.row.name)">
              <b-icon icon="square-edit-outline" />
            </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <upload-form v-if="showDetail" :item="file" :directory="directory" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { readDirectory, deleteDownloadFile } from "../api/methods";
import config from "../config/config";
import { toMillitime } from "../api/helpers";
import { fileSchema } from "../store/schemas";
import filters from "../mixins/filters";
import UploadForm from "./UploadForm";
import { bus } from "../main";

export default {
  name: "UploadList",
  components: {
    UploadForm
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      showDetail: false,
      currKey: "",
      directory: "files",
      file: {
        type: Object,
        default() {
          return fileSchema;
        }
      }
    };
  },
  computed: {
    ...mapGetters(["settings", "user"]),
    wrapperClasses() {
      let cls = ["files"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    numItems() {
      return this.items.length;
    }
  },
  created() {
    bus.$on("escape", val => {
      if (val) {
        this.close();
        this.cancelRemove();
      }
    });
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split("/");
      if (parts.length > 1) {
        this.currKey = parts[1];
      }
    }
    this.mapFiles();
    setTimeout(() => {
      this.mapFiles();
    }, 500);
  },
  filters: {},
  methods: {
    mapFiles() {
      const directoryPath = config.mediaPath.replace(
        "/media",
        "/" + this.directory
      );
      readDirectory(this.directory).then(data => {
        if (data.files instanceof Array) {
          this.items = data.files.map(file => {
            file.extension = file.name.split(".").pop();
            file.fullPath = directoryPath + file.name;
            file.showDelete = false;
            return file;
          });
          this.items.sort(
            (a, b) => toMillitime(b.mtime) - toMillitime(a.mtime)
          );
        }
      });
    },
    editFile(name) {
      const file = this.items.find(s => s.name === name);
      if (file instanceof Object) {
        if (file.name) {
          this.file = file;
          const newPath = "/uploads/" + name;
          if (this.$route.path !== newPath) {
            this.$router.push(newPath);
          }
          this.showDetail = true;
        }
      }
    },
    showNewFile() {
      this.file = fileSchema;
      this.name = "";
      this.showDetail = true;
    },
    close() {
      this.showDetail = false;
      const newPath = this.$route.path
        .substring(1)
        .split("/")
        .shift();
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
    removeFile(filename) {
      this.items = this.items.map(item => {
        item.showDelete = item.name === filename;
        return item;
      });
    },
    cancelRemove() {
      this.items = this.items.map(item => {
        item.showDelete = false;
        return item;
      });
    },
    deleteFile(filename) {
      if (typeof filename === "string") {
        deleteDownloadFile(this.user._id, filename).then(data => {
          if (data.msg) {
            this.$buefy.toast.open({
              duration: 5000,
              message: data.msg,
              position: "is-bottom",
              type: data.valid ? "is-success" : "is-warning"
            });
            if (data.valid) {
              this.items = this.items.filter(item => item.name !== filename);
            }
          }
        });
      }
    }
  }
};
</script>
